/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Add_Voices_LabelInputs */

const en_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Voices`)
};

const fr_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des voix`)
};

const de_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimmen hinzufügen`)
};

const it_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi voci`)
};

const ru_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить голоса`)
};

const es_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar voces`)
};

const zh_cn2_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加声音`)
};

const ja_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を追加する`)
};

const hi_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाजें जोड़ें`)
};

const pt_pt2_voices_add_voices_label = /** @type {(inputs: Voices_Add_Voices_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar vozes`)
};

/**
* | output |
* | --- |
* | "Add Voices" |
*
* @param {Voices_Add_Voices_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_add_voices_label = /** @type {((inputs?: Voices_Add_Voices_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Add_Voices_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_add_voices_label(inputs)
	if (locale === "de") return de_voices_add_voices_label(inputs)
	if (locale === "it") return it_voices_add_voices_label(inputs)
	if (locale === "ru") return ru_voices_add_voices_label(inputs)
	if (locale === "es") return es_voices_add_voices_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_add_voices_label(inputs)
	if (locale === "ja") return ja_voices_add_voices_label(inputs)
	if (locale === "hi") return hi_voices_add_voices_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_add_voices_label(inputs)
	return en_voices_add_voices_label(inputs)
});